import { render } from "./BannedDomainsImportModal.vue?vue&type=template&id=1aaf3071"
import script from "./BannedDomainsImportModal.vue?vue&type=script&lang=js"
export * from "./BannedDomainsImportModal.vue?vue&type=script&lang=js"

import "./BannedDomainsImportModal.vue?vue&type=style&index=0&id=1aaf3071&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__